import * as PusherPushNotifications from "@pusher/push-notifications-web";

try {
    window.beamsClient = new PusherPushNotifications.Client({
        instanceId: window.env.MIX_PUSHER_BEAMS_APP_ID,
    });
} catch (error)  {
    console.error(error);
}

export const initBeamsClient = (user) => {
    if (!window.beamsClient)  {
        return;
    }

    try {
        const beamsTokenProvider = new PusherPushNotifications.TokenProvider({
            url: "/api/pusher/token",
        });

        window.beamsClient
            .start()
            .then(() => window.beamsClient.setUserId(`${user.id}`, beamsTokenProvider))
            .catch(console.error);
    } catch (error) {
        console.error(error);
    }
};

export const clearBeamsClient = () => {
    if (!window.beamsClient)  {
        return;
    }

    try {
        window.beamsClient
            .clearAllState()
            .then()
            .catch(console.error);
    } catch (error) {
        console.error(error);
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/include/Pusher.js